{
    "account": "Cuenta",
    "add_bookmark": "Marcar este mensaje",
    "add_date": "Añadir una fecha",
    "ago": "Hace {{duration}}",
    "api_key": "Clave API",
    "are_you_sure": "Estás seguro ?",
    "ask_delete_message": "¿Borrar este mensaje?",
    "audio_not_ready": "El audio aún no está listo.",
    "bookmark_added": "Mensaje en favoritos.",
    "bookmark_removed": "Se eliminó el marcador de mensajes.",
    "bookmarks": "marcadores",
    "cancel": "Cancelar",
    "cancel_write": "¿Quieres cancelar este nuevo mensaje?",
    "changed_group_name": "cambió el nombre del grupo",
    "confirm_password_placeholder": "confirmar contraseña",
    "connect": "Conectarse",
    "create_a_group": "Crear un grupo",
    "create_the_group": "Crear el grupo",
    "daily": "Diario",
    "default_group": "Grupo predeterminado",
    "delete": "Borrar",
    "destroy_account": "Borrar la cuenta",
    "destroy_account_explain": "Una vez que elimines tu cuenta, no hay vuelta atrás.",
    "edit": "Editar",
    "email": "Correo electrónico",
    "email_input": "Escriba aquí su dirección de correo electrónico",
    "empty_message": "El mensaje está vacío y no se puede enviar.",
    "error_new_message": "Se ha producido un error al enviar su mensaje.",
    "error": "Se ha producido un error",
    "error_upload": "Se ha producido un error durante la carga",
    "forgot_password": "¿Olvidaste tu contraseña?",
    "group_left": "Has dejado el grupo.",
    "groups": "Grupos",
    "group_share_choice": "¿A qué grupo quieres enviar este mensaje?",
    "group_updated": "El grupo ha sido actualizado.",
    "has_commented_on": "ha comentado",
    "has_joined": "se has unido",
    "has_left": "ha dejado",
    "has_posted_in": "ha publicado en",
    "hourly": "Cada hora",
    "in": "en",
    "Invalid login/password": "Usuario o contraseña incorrecto",
    "invitation_link": "Enlace de invitación",
    "invitation_welcome": "Bienvenido a Zusam. Por favor, regístrate antes de unirte al grupo.",
    "just_now": "Ahora",
    "lang": "idioma",
    "login": "Iniciar sesión",
    "login_input": "Elige un usuario",
    "login_placeholder": "correo electrónico",
    "logout": "Desconectarse",
    "mark_all_as_read": "marcar todo como leido",
    "monthly": "Mensual",
    "multiple_photos_upload": "Se ha producido un error. Intenta subir las imágenes una a una (esto puede ocurrir en algunos navegadores)",
    "name_input": "Elige un nombre",
    "name": "Nombre",
    "new_password_placeholder": "nueva contraseña",
    "next_coms": "Ver los siguientes comentarios",
    "none": "Ninguno",
    "notification_emails": "Notificaciones por correo electrónico",
    "notification_emails_stopped": "¡Se han detenido las notificaciones por correo electrónico!",
    "notifications": "notificaciones",
    "parent_message": "Mensaje para padres",
    "password": "Contraseña",
    "password_input": "Indicar una nueva contraseña",
    "password_placeholder": "contraseña",
    "password_reset_mail_sent": "Busque el correo electrónico de restablecimiento de la contraseña en su bandeja de entrada.",
    "passwords_dont_match": "Las contraseñas no coinciden",
    "previous_coms": "Ver los comentarios anteriores",
    "public_link": "enlace público",
    "publish_in_group": "publicar en el grupo",
    "quit_group": "Dejar el grupo",
    "remove_bookmark": "Desmarcar este mensaje",
    "replies_one": "{{count}} respuesta",
    "replies_other": "{{count}} respuestas",
    "reply": "responder",
    "reset_api_key": "Restablecer la clave API (se desconectará)",
    "reset_invitation_link": "Cambiar el enlace de invitación",
    "reset_password_title": "Cambia tu contraseña",
    "save_changes": "Guardar los cambios",
    "search_in_group": "buscar en este grupo",
    "search_without_result": "Su búsqueda no coincide con ningún mensaje.",
    "settings": "Parámetros",
    "settings_updated": "Sus ajustes fueron actualizados",
    "share_message": "comparte el mensaje",
    "signup": "Inscribirse",
    "submit": "Enviar",
    "text_placeholder": "Escribe tu mensaje aquí",
    "the_message_from": "el mensaje de",
    "title_placeholder": "Asunto (opcional)",
    "to": "a",
    "upload_audio": "Añadir un archivo de audio.",
    "upload_image": "Añadir fotos",
    "upload_music": "Añadir música",
    "upload_pdf": "Añadir PDF",
    "upload_video": "Añadir video",
    "User not found": "El usuario no existe",
    "users": "usuarios",
    "video_not_ready": "El vídeo aún no está listo.",
    "weekly": "Semanal"
}
